import apiSlice from "../../app/api/apiSlice";

export const cargoApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getBarData: builder.query({
			query: () => `/api/info-bar`,
			providesTags: [{ type: "InfoBar", id: "LIST" }],
		}),
		updateBar: builder.mutation({
			query: ({ data }) => ({
				url: `/api/info-bar`,
				method: "PUT",
				body: { ...data },
			}),
			invalidatesTags: [{ type: "InfoBar", id: "LIST" }],
		}),
	}),
	overrideExisting: true,
});

export const { useGetBarDataQuery, useUpdateBarMutation } = cargoApiSlice;
